/**
 * documentStore.ts
 * Shared module-level store for association documents.
 * Keeps document list in sync between DocumentConfig (settings) and ActivityFormModal.
 */

export type DocType = "charter" | "disclaimer" | "privacy" | "code";

export interface SharedDoc {
  id: string;
  title: string;
  type: DocType;
  requireSign: boolean;
  version: string;
  isActive: boolean;
}

export const docTypeConfig: Record<DocType, { label: string; icon: string; color: string }> = {
  charter:    { label: "管理章程", icon: "ri-file-shield-2-line",  color: "text-red-600 bg-red-50" },
  disclaimer: { label: "免责声明", icon: "ri-shield-check-line",   color: "text-amber-600 bg-amber-50" },
  privacy:    { label: "隐私政策", icon: "ri-lock-2-line",         color: "text-green-600 bg-green-50" },
  code:       { label: "行为准则", icon: "ri-book-mark-line",      color: "text-gray-600 bg-gray-100" },
};

const _docs: SharedDoc[] = [
  { id: "d1", title: "球迷协会管理章程", type: "charter",    requireSign: false, version: "v2.1", isActive: true },
  { id: "d2", title: "会员服务免责声明",     type: "disclaimer", requireSign: true,  version: "v1.3", isActive: true },
  { id: "d3", title: "隐私政策",             type: "privacy",    requireSign: false, version: "v1.1", isActive: true },
  { id: "d4", title: "球迷行为准则",         type: "code",       requireSign: true,  version: "v3.0", isActive: true },
];

export const documentStore = {
  getAll: (): SharedDoc[] => [..._docs],
  getActive: (): SharedDoc[] => _docs.filter((d) => d.isActive),
  getById: (id: string): SharedDoc | undefined => _docs.find((d) => d.id === id),
  syncFromSettings: (docs: SharedDoc[]) => {
    _docs.length = 0;
    docs.forEach((d) => _docs.push(d));
  },
};
